import { useState } from 'react'
import { LoadingView } from '../../components/LoadingView'
import { Button } from 'baseui/button';
import { BacnetObjectTypes } from '../../services/mapping/bacnet';
import { useStyletron } from 'baseui';
import { HeadingXSmall } from 'baseui/typography';
import { Drawer } from "baseui/drawer";
import { NotificationCircle } from 'baseui/badge';
import { VscLink } from 'react-icons/vsc';
import { Spinner } from 'baseui/spinner';
import { BanetPropertyMappingListItem } from './BacnetMapping/BanetPropertyMappingListItem';
import { BacnetObjectMapppingListItem } from './BacnetMapping/BacnetObjectMapppingListItem';
import { useGetBacnetObjectMappingsByObject, useGetBacnetPropertyMappingsByObject } from '../../hooks/useGetBacnetMappings';


export const BacnetCheckObjectMapping = (props: { edgeDeviceId: string,
    deviceId: number,
    instanceId: number,
    objectType: BacnetObjectTypes}) => {


    const [css, theme] = useStyletron();
    const { objects: data, error, isLoading, isSuccess } = useGetBacnetObjectMappingsByObject(props.edgeDeviceId, props.deviceId, props.objectType,  props.instanceId);
    const { objects: propData } = useGetBacnetPropertyMappingsByObject(props.edgeDeviceId,props.deviceId, props.objectType, props.instanceId);
    const [isOpen, setIsOpen] = useState(false);

    const hasData = (propData ? propData?.length > 0 : false) || (data ? data.length > 0 : false);
    const numLinks = (data?.length ?? 0) + (propData ? propData.length : 0);


    if (isLoading)
        return <div className={css({ width: theme.sizing.scale1200 })}><Spinner $size={'small'} /></div>
    return (
        <>
            {hasData &&
                (
                    <>
                        <NotificationCircle
                            content={numLinks}
                            color={'accent'}
                            placement={'topRight'}
                            horizontalOffset="-2px"
                            verticalOffset="-2px"
                        >
                            <Button onClick={() => setIsOpen(true)} shape='round' kind='tertiary'>
                                <VscLink />
                            </Button>
                        </NotificationCircle>
                        <Drawer
                            isOpen={isOpen}
                            autoFocus
                            onClose={() => setIsOpen(false)}
                        >
                            <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
                                <MappingDetailsPanel data={data} propData={propData} {...props}></MappingDetailsPanel>
                            </LoadingView>
                        </Drawer>

                    </>
                )
            }
            {!hasData &&
                <div className={css({ width: theme.sizing.scale1200 })}></div>
            }
        </>
    )
}


const MappingDetailsPanel = (props: { data: any, propData: any, edgeDeviceId: string, deviceId: number, objectType: BacnetObjectTypes, instanceId: number }) => {
    const [css, theme] = useStyletron();
    const { data, propData } = props;
    return (
        <>
            {data && data.length > 0 &&
                <>
                    <HeadingXSmall>Object Mappings</HeadingXSmall>
                    <ul className={css({
                        width: 'auto',
                        paddingLeft: 0,
                        paddingRight: 0,
                        marginLeft: 0
                    })}>
                        {data?.map((item: any, index: number) =>
                            <BacnetObjectMapppingListItem item={item}></BacnetObjectMapppingListItem>
                        )}
                    </ul>
                </>}
            {propData && propData.length > 0 &&
                <>
                    <HeadingXSmall>Property Mappings</HeadingXSmall>
                    <ul className={css({
                        width: 'auto',
                        paddingLeft: 0,
                        paddingRight: 0,
                        marginLeft: 0
                    })}>
                        {propData?.map((item: any, index: number) =>
                            <BanetPropertyMappingListItem item={item}></BanetPropertyMappingListItem>
                        )}
                    </ul>
                </>}
        </>)
}
